import { cn } from '@/lib/utils';

interface Lot {
  strain: string;
  form: string;
  price: string;
  /** Interest that came back to this lot. */
  marks: number;
}

const lots: Lot[] = [
  { strain: 'Blue Dream', form: 'Indoor · B-Flower', price: '$0.75 / g', marks: 3 },
  { strain: 'Gelato 41', form: 'Greenhouse · A/B Flower Mix', price: '$575 / lb', marks: 0 },
  { strain: 'Papaya Live Rosin', form: 'Extract', price: '$3.50 / g', marks: 5 },
  { strain: 'Wedding Cake', form: 'Indoor · Scissor Trim, Dry', price: '$90 / lb', marks: 1 },
];

/**
 * The page's visual signature: a menu leaves, and interest returns as soft
 * orange marks settling on a few lots. Pure markup — never goes stale.
 */
const SignalArt = ({ className }: { className?: string }) => (
  <div className={cn('relative', className)} aria-hidden="true">

    <div className="rounded-xl border border-white/10 bg-white/[0.04] p-4 shadow-2xl backdrop-blur sm:p-5">
      <div className="flex items-center justify-between border-b border-white/10 pb-3">
        <p className="text-xs font-medium uppercase tracking-wide text-background/60">
          Menu sent · Tuesday 8:04 am
        </p>
        <span className="flex items-center gap-1.5 text-xs text-brand-text">
          <span className="circle-1.5 bg-brand motion-safe:animate-soft-pulse" />
          Interest returning
        </span>
      </div>

      <ul className="divide-y divide-white/5">
        {lots.map((lot, i) => (
          <li key={lot.strain} className="flex items-center justify-between gap-3 py-3">
            <div className="min-w-0">
              <p className="truncate text-sm font-medium text-background">{lot.strain}</p>
              <p className="text-xs text-background/50">
                {lot.form} · {lot.price}
              </p>
            </div>
            <div className="flex shrink-0 items-center gap-1">
              {Array.from({ length: lot.marks }).map((_, m) => (
                <span
                  key={m}
                  style={{ animationDelay: `${900 + i * 260 + m * 110}ms` }}
                  className="circle-2 bg-brand motion-safe:animate-mark-settle"
                />
              ))}
              {lot.marks === 0 && (
                <span className="text-xs text-background/35">quiet</span>
              )}
            </div>
          </li>
        ))}
      </ul>

      <p className="border-t border-white/10 pt-3 text-xs text-background/60">
        Two listings earned most of the attention. That’s where the morning goes.
      </p>
    </div>
  </div>
);

export default SignalArt;